import { render, staticRenderFns } from "./gradent.vue?vue&type=template&id=1aa65994&scoped=true&"
import script from "./gradent.vue?vue&type=script&lang=js&"
export * from "./gradent.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/style.css?vue&type=style&index=0&id=1aa65994&prod&scoped=true&lang=css&"
import style1 from "./gradent.vue?vue&type=style&index=1&id=1aa65994&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa65994",
  null
  
)

export default component.exports